import { Anchor, Stack, Title } from '@mantine/core';
import { Link } from 'react-router';
import { t } from '../texts/pl';

export function NotFoundPage() {
  return (
    <Stack gap="md">
      <Title order={1}>{t.notFound.title}</Title>
      <Anchor component={Link} to="/">
        {t.notFound.back}
      </Anchor>
    </Stack>
  );
}
